/**
 * FP10 issue swiper — Swiper + tab / arrow sync.
 * Root: [data-fp10-issue-swiper]
 */
(function () {
  'use strict';

  function setUiState(root, index, slideCount) {
    var i = Math.max(0, Math.min(slideCount - 1, index));

    root.querySelectorAll('[data-issue-tab]').forEach(function (btn, idx) {
      var on = idx === i;
      btn.classList.toggle('active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    root.querySelectorAll('[data-icons-panel]').forEach(function (panel, idx) {
      panel.hidden = idx !== i;
    });

    var currentEl = root.querySelector('[data-mob-current]');
    if (currentEl) {
      currentEl.textContent = String(i + 1).padStart(2, '0');
    }

    root.querySelectorAll('.arrow[data-dir="prev"]').forEach(function (el) {
      el.classList.toggle('is-disabled', i === 0);
    });
    root.querySelectorAll('.arrow[data-dir="next"]').forEach(function (el) {
      el.classList.toggle('is-disabled', i >= slideCount - 1);
    });
  }

  function getUiIndex(swiper, slideCount) {
    if (!swiper) return 0;
    var maxProgress = typeof swiper.progress === 'number' ? swiper.progress : 0;
    if (slideCount > 0 && (swiper.isEnd || maxProgress >= 0.999)) return slideCount - 1;
    return swiper.activeIndex || 0;
  }

  function initFp10IssueSwiper(root) {
    if (!root || root.getAttribute('data-fp10-issue-initialized') === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var slideCount = parseInt(root.getAttribute('data-slide-count') || '0', 10) || 0;
    if (slideCount < 1) return;

    var swiperEl = root.querySelector('.hair-comparison-solutions-swiper');
    if (!swiperEl) return;

    root.setAttribute('data-fp10-issue-initialized', 'true');

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1.1,
      spaceBetween: 20,
      normalizeSlideIndex: true,
      watchOverflow: true,
      breakpointsInverse: true,
      breakpoints: {
        851: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
      on: {
        slideChange: function () {
          setUiState(root, getUiIndex(this, slideCount), slideCount);
        },
        slideChangeTransitionEnd: function () {
          setUiState(root, getUiIndex(this, slideCount), slideCount);
        },
        touchEnd: function () {
          setUiState(root, getUiIndex(this, slideCount), slideCount);
        },
        reachEnd: function () {
          setUiState(root, slideCount - 1, slideCount);
        },
      },
    });

    root._fp10IssueSwiper = swiper;

    root.querySelectorAll('[data-issue-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-issue-tab') || '0', 10) || 0;
        swiper.slideTo(idx);
      });
    });

    root.querySelectorAll('[data-issue-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        swiper.slidePrev();
      });
    });
    root.querySelectorAll('[data-issue-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        swiper.slideNext();
      });
    });

    root.querySelectorAll('.arrow[data-dir="prev"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.classList.contains('is-disabled')) {
          var currentIdx = getUiIndex(swiper, slideCount);
          var prevIdx = Math.max(0, currentIdx - 1);
          swiper.slideTo(prevIdx);
          setUiState(root, prevIdx, slideCount);
        }
      });
    });
    root.querySelectorAll('.arrow[data-dir="next"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.classList.contains('is-disabled')) {
          var currentIdx = getUiIndex(swiper, slideCount);
          var nextIdx = Math.min(slideCount - 1, currentIdx + 1);
          swiper.slideTo(nextIdx);
          setUiState(root, nextIdx, slideCount);
        }
      });
    });

    setUiState(root, getUiIndex(swiper, slideCount), slideCount);
  }

  function initAll() {
    document.querySelectorAll('[data-fp10-issue-swiper]').forEach(initFp10IssueSwiper);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev || !ev.target) return;
    ev.target.querySelectorAll('[data-fp10-issue-swiper]').forEach(initFp10IssueSwiper);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    if (!ev || !ev.target) return;
    ev.target.querySelectorAll('[data-fp10-issue-swiper]').forEach(function (root) {
      if (root._fp10IssueSwiper && typeof root._fp10IssueSwiper.destroy === 'function') {
        root._fp10IssueSwiper.destroy(true, true);
        root._fp10IssueSwiper = null;
      }
      root.removeAttribute('data-fp10-issue-initialized');
    });
  });
})();

